import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import RedirectRoute from './components/RedirectRoute'
import { REDIRECTS } from './i18n/routes'

// Danish Pages (Primary default language)
import HomePage from './pages/HomePage'
import WebshopPage from './pages/WebshopPage'
import ForhandlerlistePage from './pages/ForhandlerlistePage'
import FindMigPage from './pages/FindMigPage'
import OmMigPage from './pages/OmMigPage'
import ForspoergselPage from './pages/ForspoergselPage'
import BetingelserPage from './pages/BetingelserPage'
import ForbiddenPage from './pages/ForbiddenPage'
import NotFoundPage from './pages/NotFoundPage'

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#FDF8F7] text-[#3E3435]">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* =========================================
                1. DANISH ROUTES (Standardsprog / Root)
               ========================================= */}
            <Route path="/" element={<HomePage />} />
            <Route path="/webshop" element={<WebshopPage />} />
            <Route path="/forhandlerliste" element={<ForhandlerlistePage />} />
            <Route path="/aabningstider-og-adresse" element={<FindMigPage />} />
            <Route path="/om-mig" element={<OmMigPage />} />
            <Route path="/forspoergsel" element={<ForspoergselPage />} />
            <Route path="/betingelser" element={<BetingelserPage />} />
            <Route path="/403" element={<ForbiddenPage />} />

            {/* =========================================
                2. ENGLISH ROUTES (/en/...)
               ========================================= */}
            <Route path="/en" element={<HomePage lang="en" />} />
            <Route path="/en/shop" element={<WebshopPage lang="en" />} />
            <Route path="/en/retailers" element={<ForhandlerlistePage lang="en" />} />
            <Route path="/en/opening-hours-and-location" element={<FindMigPage lang="en" />} />
            <Route path="/en/about-me" element={<OmMigPage lang="en" />} />
            <Route path="/en/eu-lag-support" element={<RedirectRoute to="/en/about-me#projektstoette" />} />
            <Route path="/en/cake-inquiry" element={<ForspoergselPage lang="en" />} />
            <Route path="/en/terms" element={<BetingelserPage lang="en" />} />
            <Route path="/en/403" element={<ForbiddenPage lang="en" />} />
            <Route path="/en/*" element={<NotFoundPage lang="en" />} />

            {/* =========================================
                3. GERMAN ROUTES (/de/...)
               ========================================= */}
            <Route path="/de" element={<HomePage lang="de" />} />
            <Route path="/de/shop" element={<WebshopPage lang="de" />} />
            <Route path="/de/haendler" element={<ForhandlerlistePage lang="de" />} />
            <Route path="/de/oeffnungszeiten-und-adresse" element={<FindMigPage lang="de" />} />
            <Route path="/de/ueber-mich" element={<OmMigPage lang="de" />} />
            <Route path="/de/eu-lag-foerderung" element={<RedirectRoute to="/de/ueber-mich#projektstoette" />} />
            <Route path="/de/tortenanfrage" element={<ForspoergselPage lang="de" />} />
            <Route path="/de/agb" element={<BetingelserPage lang="de" />} />
            <Route path="/de/403" element={<ForbiddenPage lang="de" />} />
            <Route path="/de/*" element={<NotFoundPage lang="de" />} />

            {/* =========================================
                4. 301 PERMANENT REDIRECTS
                (Old & variant URLs redirect to canonical)
               ========================================= */}
            {REDIRECTS.map((redir) => (
              <Route
                key={redir.from}
                path={redir.from}
                element={<RedirectRoute to={redir.to} />}
              />
            ))}

            {/* =========================================
                5. DEFAULT CATCH-ALL (404)
               ========================================= */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  )
}
